import { createFileRoute } from "@tanstack/react-router";
import Affiliate from "../components/tk/pages/Affiliate";

const title = "Affiliate Programme — Refer Restaurants & Earn 5% Commission | thatKorner";
const description = "Help restaurants discover Chef Buddy and Chef Brain with That Korner. Introduce our platform to your network and earn a 5% commission on the first eligible payment from every successful referral.";

export const Route = createFileRoute("/affiliate")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.thatkorner.com/affiliate" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: "https://www.thatkorner.com/affiliate" }],
  }),
  component: Affiliate,
});
